/*
 * @Author: pyx 3245266940@qq.com
 * @Date: 2022-07-30 11:44:30
 * @LastEditors: pyx 3245266940@qq.com
 * @LastEditTime: 2023-04-19 15:44:30
 * @FilePath: \org-wx-front\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vant from 'vant';
import { Picker } from 'vant';
import 'vant/lib/index.css';
import './assets/iconfont/style.css'
import './assets/css/common.scss'
import './assets/css/vant.scss'
// import Vconsole from 'vconsole';

// let vConsole = new Vconsole();

// export default vConsole

Vue.use(Vant);
import '@/assets/css/reset.css'

import {common} from './utils/common.js'
Vue.prototype.$common = common

Vue.use(Picker);

Vue.config.productionTip = false



new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
